import { HeaderDropdowns } from '@/components/NewHeader/HeaderDropdowns';
import ShortListModalContent from '@/components/ShortListModalContent';
import { useTranslation } from '@/contexts/dictionaryContext';
import { cn } from '@/lib/utils';
import { FC } from 'react';
import { MdOutlinePhone } from 'react-icons/md';

interface HeaderSelectProps {
  atFooter?: boolean;
  isActive?: boolean;
}

const HeaderSelect: FC<HeaderSelectProps> = ({ isActive = false }) => {
  const { header } = useTranslation();

  return (
    <>
      <div
        className={cn(
          'flex flex-col mobileL:flex-row desktop:items-center gap-6 desktop:gap-0 transition-colors',
        )}>
        <div className="relative flex flex-row desktop:px-2 xl:px-[0.9375rem] gap-4 items-center justify-center">
          <div className="flex items-center gap-3">
            <MdOutlinePhone
              width={16}
              height={16}
              className={cn(
                'desktop:hidden',
                isActive ? 'fill-black/90' : 'fill-white',
              )}
            />
            <a
              href={`tel:${header.nav.phone.replace(/ /g, '')}`}
              className="text-sm whitespace-nowrap"
              title="Contact Us">
              {header.nav.phone}
            </a>
          </div>

          <Divider isActive={isActive} />

          {/* <div className="flex items-center">
            <RequestCallbackModal
              lang={lang}
              dict={contactUsDict}
              countriesDict={countriesDict}>
              <div>
                <MdPhoneCallback
                  width={16}
                  height={16}
                  className={cn(
                    `cursor-pointer hover:scale-110 transition-transform duration-300 ease-in-out`,
                    isActive ? 'fill-black/90' : 'fill-white',
                  )}
                />
              </div>
            </RequestCallbackModal>
          </div>

          <Divider isActive={isActive} /> */}

          <div className="hidden desktop:flex items-center">
            <ShortListModalContent />
          </div>
        </div>

        <div className="relative desktop:px-2 flex gap-2">
          <HeaderDropdowns />
        </div>
      </div>
    </>
  );
};

function Divider({ isActive }: { isActive: boolean }) {
  return (
    <div
      className={cn(
        'h-6 w-px bg-white opacity-80 hidden mobileL:block my-auto',
        isActive && 'bg-black/90',
      )}
    />
  );
}

export default HeaderSelect;
